<template>
  <b-container class="admin-auth-container">
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="
      dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p style="margin: 0">已複製 Email 到剪貼簿</p>
    </b-alert>

    <b-card
      header="業務帳號管理"
      v-if="activeAccountsList.length"
    >
      <b-list-group>
        <b-list-group-item
          href="#"
          @click="showModal"
        >
          <b-icon-plus-square-fill />
          新增業務帳號
        </b-list-group-item>
        <b-list-group-item
          class="accountItem"
          title="編輯此分類"
          href="#"
          v-for="account in activeAccountsList"
          :key="account.id"
        >
          <span>
            {{ account.name }} ({{ account.email }})
            <b-icon-files
              v-b-tooltip.right.hover
              title="複製 Email"
              @click="copyCodeToClipboard(account.email)"
            />
          </span>
          <b-button
            size="sm"
            @click="archiveAccount({id: account.id})"
          >刪除帳號</b-button>
        </b-list-group-item>
      </b-list-group>
    </b-card>
    <b-modal
      id="modal-1"
      title="Add New Seles Account"
      hide-footer
    >
      <b-form
        @submit="submit"
        @reset="reset"
      >
        <b-form-group
          id="input-group-1"
          label="登入 Email"
          label-for="input-1"
          description="此信箱會直接作為業務登入的帳號"
        >
          <b-form-input
            id="input-1"
            v-model="formData.email"
            type="email"
            required
            placeholder="Enter Email"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="登入密碼"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="formData.password"
            required
            placeholder="Enter Password"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          label="Your Name:"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="formData.name"
            required
            placeholder="輸入業務名稱"
          ></b-form-input>
        </b-form-group>

        <b-button
          type="submit"
          variant="primary"
        >Submit</b-button>
        <b-button
          type="reset"
          variant="danger"
        >Reset</b-button>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
  import { mapActions, mapState } from "vuex";

  export default {
    mounted() {
      this.queryAccountList();
    },
    data() {
      return {
        formData: {
          authority: "sales",
          permission: "sales",
        },
        dismissSecs: 3,
        dismissCountDown: 0,
        showDismissibleAlert: false,
      };
    },
    computed: {
      ...mapState("login", ["account", "accountsList"]),

      activeAccountsList: function () {
        return this.accountsList.filter((account) => !account.isArchive);
      },
    },
    methods: {
      ...mapActions("login", [
        "registeAccount",
        "queryAccountList",
        "archiveAccount",
      ]),

      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown;
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs;
      },
      copyCodeToClipboard(text) {
        navigator.clipboard.writeText(text);
        this.showAlert();
      },
      showModal: function () {
        this.$bvModal.show("modal-1");
      },
      submit: async function (e) {
        e.preventDefault();
        const { success } = await this.registeAccount({ ...this.formData });
        if (success) {
          this.$bvModal.hide("modal-1");
          this.reset();
        }
      },
      reset: function () {
        this.formData = {
          authority: "sales",
          permission: "sales",
        };
      },
    },
  };
</script>
